<template>
    <v-app-bar color="base-brand-blue" class="d-flex justify-end">
        <crvCooperationLogoWhite class="crv-cooperation-logo-white pa-2 me-auto" @click="goBackHome"/>
        <crv-app-locale-switcher 
            :model-value="$i18n.locale"
            :tooltip-text="$t('localeSwitcher.tooltip')"
            :locales="locales"
            @update:model-value="handleSelectLocale"
        />
    </v-app-bar>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { defaultLocale } from "../i18n/config";
import crvCooperationLogoWhite from '../assets/logo/crvCooperationLogoWhite.vue';
import { mapMutations } from "vuex";
import { CrvAppLocaleSwitcher } from '@crv/vue-3-components'
import { Locales } from '../i18n/config/locales'


export default defineComponent({
    name: "SireHeader",
    components: { 
        crvCooperationLogoWhite,
        CrvAppLocaleSwitcher,
    },
    data: () => ({
        defaultLocale,
        locales: [Locales.en, Locales.nl],
    }),
 
    methods: {
        ...mapMutations({
            setBullDetail: "setBullDetail",
            jumpHistory: "jumpHistory",
        }),
        handleSelectLocale(locale: string) {
            this.$router.replace({ params: { locale } });
        },
        async goBackHome() {
            this.jumpHistory(0)
            await this.$router.push({ name: 'search', params: { locale: this.$i18n.locale } })
        }
    },
});
</script>

<style lang="scss" scoped>
@import "@crv/vue-3-components/assets/styles/variables.scss";

.crv-cooperation-logo-white {
    width: 150px;
    height: 60px;
    cursor: pointer;
}
</style>
